import React from "react";

const buttonStyle = {
    padding: '8px 16px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
};

const disabledButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#ccc',
    cursor: 'not-allowed',
};

const PDFViewerControls = ({currentPageNumber, setCurrentPageNumber, numPages}) => {
    const goToNextPage = () => setCurrentPageNumber(Math.min(numPages, currentPageNumber + 1));
    const goToPreviousPage = () => setCurrentPageNumber(Math.max(1, currentPageNumber - 1));
    return (
        <div style={{
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            borderTop: '1px solid #ccc',
            backgroundColor: '#f9f9f9',
        }}>
            <button
                onClick={goToPreviousPage}
                disabled={currentPageNumber <= 1}
                style={currentPageNumber <= 1 ? disabledButtonStyle : buttonStyle}>
                Previous
            </button>

            <span style={{fontSize: '14px', color: '#333'}}>
                Page {currentPageNumber} of {numPages}
            </span>

            <button
                onClick={goToNextPage}
                disabled={currentPageNumber >= numPages}
                style={currentPageNumber >= numPages ? disabledButtonStyle : buttonStyle}>
                Next
            </button>
        </div>

    )
}

export default PDFViewerControls;
